/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type {
    GetSitesByParcelIdParams,
    GetSitesParams,
    PagedResponseSiteResponse,
    SiteCreateRequest,
    SiteResponse,
    SiteUpdateRequest,
    SiteWithParcelAndClientResponse
} from '../models';

export type getSiteResponse200 = {
    data: SiteWithParcelAndClientResponse;
    status: 200;
};

export type getSiteResponse400 = {
    data: void;
    status: 400;
};

export type getSiteResponse500 = {
    data: void;
    status: 500;
};

export type getSiteResponseSuccess = getSiteResponse200 & {
    headers: Headers;
};

export type getSiteResponseError = (getSiteResponse400 | getSiteResponse500) & {
    headers: Headers;
};

export type getSiteResponse = getSiteResponseSuccess | getSiteResponseError;

export const getGetSiteUrl = (siteId: string) => `/api/v1/sites/${siteId}`;

export const getSite = async (siteId: string, options?: RequestInit): Promise<getSiteResponse> => {
    const res = await fetch(getGetSiteUrl(siteId), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getSiteResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getSiteResponse;
};

export type updateSiteResponse200 = {
    data: SiteResponse;
    status: 200;
};

export type updateSiteResponse400 = {
    data: void;
    status: 400;
};

export type updateSiteResponse500 = {
    data: void;
    status: 500;
};

export type updateSiteResponseSuccess = updateSiteResponse200 & {
    headers: Headers;
};

export type updateSiteResponseError = (updateSiteResponse400 | updateSiteResponse500) & {
    headers: Headers;
};

export type updateSiteResponse = updateSiteResponseSuccess | updateSiteResponseError;

export const getUpdateSiteUrl = (siteId: string) => `/api/v1/sites/${siteId}`;

export const updateSite = async (
    siteId: string,
    siteUpdateRequest: SiteUpdateRequest,
    options?: RequestInit
): Promise<updateSiteResponse> => {
    const res = await fetch(getUpdateSiteUrl(siteId), {
        ...options,
        body: JSON.stringify(siteUpdateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'PUT'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: updateSiteResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as updateSiteResponse;
};

export type archiveSiteResponse200 = {
    data: SiteResponse;
    status: 200;
};

export type archiveSiteResponse400 = {
    data: void;
    status: 400;
};

export type archiveSiteResponse500 = {
    data: void;
    status: 500;
};

export type archiveSiteResponseSuccess = archiveSiteResponse200 & {
    headers: Headers;
};

export type archiveSiteResponseError = (archiveSiteResponse400 | archiveSiteResponse500) & {
    headers: Headers;
};

export type archiveSiteResponse = archiveSiteResponseSuccess | archiveSiteResponseError;

export const getArchiveSiteUrl = (siteId: string) => `/api/v1/sites/${siteId}/archive`;

export const archiveSite = async (
    siteId: string,
    options?: RequestInit
): Promise<archiveSiteResponse> => {
    const res = await fetch(getArchiveSiteUrl(siteId), {
        ...options,
        method: 'POST'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: archiveSiteResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as archiveSiteResponse;
};

export type getSitesByParcelIdResponse200 = {
    data: PagedResponseSiteResponse;
    status: 200;
};

export type getSitesByParcelIdResponse400 = {
    data: void;
    status: 400;
};

export type getSitesByParcelIdResponse500 = {
    data: void;
    status: 500;
};

export type getSitesByParcelIdResponseSuccess = getSitesByParcelIdResponse200 & {
    headers: Headers;
};

export type getSitesByParcelIdResponseError = (
    | getSitesByParcelIdResponse400
    | getSitesByParcelIdResponse500
) & {
    headers: Headers;
};

export type getSitesByParcelIdResponse =
    | getSitesByParcelIdResponseSuccess
    | getSitesByParcelIdResponseError;

export const getGetSitesByParcelIdUrl = (parcelId: string, params?: GetSitesByParcelIdParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['sort'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach(v => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/v1/parcels/${parcelId}/sites?${stringifiedParams}`
        : `/api/v1/parcels/${parcelId}/sites`;
};

export const getSitesByParcelId = async (
    parcelId: string,
    params?: GetSitesByParcelIdParams,
    options?: RequestInit
): Promise<getSitesByParcelIdResponse> => {
    const res = await fetch(getGetSitesByParcelIdUrl(parcelId, params), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getSitesByParcelIdResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getSitesByParcelIdResponse;
};

export type createSiteResponse201 = {
    data: SiteResponse;
    status: 201;
};

export type createSiteResponse400 = {
    data: void;
    status: 400;
};

export type createSiteResponse500 = {
    data: void;
    status: 500;
};

export type createSiteResponseSuccess = createSiteResponse201 & {
    headers: Headers;
};

export type createSiteResponseError = (createSiteResponse400 | createSiteResponse500) & {
    headers: Headers;
};

export type createSiteResponse = createSiteResponseSuccess | createSiteResponseError;

export const getCreateSiteUrl = (parcelId: string) => `/api/v1/parcels/${parcelId}/sites`;

export const createSite = async (
    parcelId: string,
    siteCreateRequest: SiteCreateRequest,
    options?: RequestInit
): Promise<createSiteResponse> => {
    const res = await fetch(getCreateSiteUrl(parcelId), {
        ...options,
        body: JSON.stringify(siteCreateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'POST'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: createSiteResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as createSiteResponse;
};

export type getSitesResponse200 = {
    data: PagedResponseSiteResponse;
    status: 200;
};

export type getSitesResponse400 = {
    data: void;
    status: 400;
};

export type getSitesResponse500 = {
    data: void;
    status: 500;
};

export type getSitesResponseSuccess = getSitesResponse200 & {
    headers: Headers;
};

export type getSitesResponseError = (getSitesResponse400 | getSitesResponse500) & {
    headers: Headers;
};

export type getSitesResponse = getSitesResponseSuccess | getSitesResponseError;

export const getGetSitesUrl = (params?: GetSitesParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['sort'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach(v => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/api/v1/sites?${stringifiedParams}` : `/api/v1/sites`;
};

export const getSites = async (
    params?: GetSitesParams,
    options?: RequestInit
): Promise<getSitesResponse> => {
    const res = await fetch(getGetSitesUrl(params), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getSitesResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getSitesResponse;
};
